




















import { Component, Vue } from 'vue-property-decorator'
import { getMyOrganization } from '@/services/organizations'
import EditDefaultWageDialog from './EditDefaultWageDialog.vue'

@Component({
  components: {
    EditDefaultWageDialog,
  },
})
export default class Organization extends Vue {

  loadingMyOrganization = false
  editOrganizationWageDialog = false

  async mounted() {
    this.loadingMyOrganization = true
    try {
      await getMyOrganization(this.$store)
    }
    finally {
      this.loadingMyOrganization = false
    }
  }

  get myOrganization() {
    return this.$store.getters.myOrganization
  }

  openEditOrganizationWageDialog() {
    this.editOrganizationWageDialog = true
  }
}
